/**
 * Created by BETALOS on 08/07/2016.
 */

(function () {

    'use strict';

    const VISIT_SUB_LINKS = require('parameters/json/visit-sub-links.json');
    const ENTRY_ROOM_UPDATE_DIALOG = require('../dialogs/entry-room-update-dialog');
    const BIOLOGY_RESULT_DIALOG = require('prescription/dialogs/biology-result-dialog/biology-result-dialog');
    const {UPDATE, APPOINTMENT, WAITING_LIST, DELETE} = require('stand-alone/calendar/utils/consts');

    class PracticeMenuCtrl {
        constructor(
            $state, mnWebSocket, frontDeskService, $mdDialog, $attrs, $element, $scope, $compile, interfacingService,
            dcmService, practiceService, visitService, notificationService, patientService, system, moment, hurService,
            configService, videoCallService, authService, CloudPlatformsService, medicalCareService, groupAppointmentService
        ) {
            this.$scope = $scope;
            this.$state = $state;
            this.moment = moment;
            this.dialog = $mdDialog;
            this.$element = $element;
            this.$compile = $compile;

            this.ws = mnWebSocket;
            this.visitService = visitService;
            this.patientService = patientService;
            this.practiceService = practiceService;
            this.frontDeskService = frontDeskService;
            this.notificationService = notificationService;
            this.configService = configService;
            this.medicalCareService = medicalCareService;
            this.videoCallService = videoCallService;
            this.groupAppointmentService = groupAppointmentService;

            this.createDcmOrder = dcmService.createDcmOrder;
            this.createHurOrder = hurService.createHurOrder;
            this.createOrder = interfacingService.createOrder;
            this.decideMethod = frontDeskService.decideMethod;
            this.createPrismaOrder = CloudPlatformsService.createPrismaOrder;

            this.dayFilter = true;
            this.item = this.item || {};
            this.callbacks = this.callbacks || {};
            this.dateFormat = system['date_format'].js;
            this.currentStaff = _.get(authService.staff, 'id', -1);
            this.isRoot = authService.isRootProfile();

            $attrs.$observe('html', () => this.compile($attrs));
        }

        static get $inject() {
            return [
                "$state", "mnWebSocket", "frontDeskService", "$mdDialog", "$attrs", "$element",
                "$scope", "$compile", "interfacingService", "dcmService", "practiceService", "visitService",
                "notificationService", "patientService", "system", "moment", "hurService", "configService",
                "videoCallService", "authService", "CloudPlatformsService", "medicalCareService", "groupAppointmentService"
            ];
        }

        $onInit() {
            this.payVisit = this.callbacks.payVisit;
            this.prePayVisit = this.callbacks.prePayVisit;
            this.editEntry = this.callbacks.editEntry;
            this.patientOut = this.callbacks.patientOut;
            this.patientFile = this.callbacks.patientFile;
            this.generateVisit = this.callbacks.generateVisit;
            this.payTreatmentPlans = this.callbacks.payTreatmentPlans;
            this.payTreatmentPlans = this.callbacks.payTreatmentPlans;
            this.payMedicalPlan = this.callbacks.payMedicalPlan;

            this.isDental = this.configService.isDental();
            this.hasMedicalCare = this.configService.hasMedicalCare();

            this.visitSubLinksSubscription = this.visitService.visitSubLinks.subscribe(
                data => this.handleSubLinks(data)
            );

            this.roomSubscription = this.frontDeskService.roomSubject
                .subscribe(data => this.rooms = _.filter(data, {type: 'WR'}));
        }

        $onDestroy() {
            if (this.roomSubscription) this.roomSubscription.unsubscribe();
            if (this.visitSubLinksSubscription) this.visitSubLinksSubscription.unsubscribe();
        }

        compile(attrs) {
            let tpl = require(
                `frontdesk/views/${attrs['compId']}-${attrs.html.toLowerCase()}-menu.tpl.html`
            );

            if (this.$element.is('[icon-button]')) {
                let $tpl = $(tpl);
                $('md-button:eq(0)', $tpl).addClass('md-icon-button');

                tpl = $tpl.prop('outerHTML');
            }

            let compiledDirective = this.$compile(tpl);
            let directiveElement = compiledDirective(this.$scope);

            this.$element.html(directiveElement);
        }

        handleSubLinks(data) {
            this.visitLinkConfig = _.find(VISIT_SUB_LINKS, ['key', _.get(data, 'favorite', 'CONSULTATION')]);
        }

        showLastVisit(item) {
            return this.$state.go(this.visitLinkConfig.link, {
                visitId: item.patient['last_visit_id'], pId: item.patient.id
            });
        }

        addNewRdv(item, ev) {
            return this.frontDeskService.addNewAppointment(item.patient, ev);
        }

        cancelEntry(item) {
            return this.frontDeskService.cancelEntry(item)
                .then(data => {
                    this.practiceService.entryCanceled(data.entry);
                    this.ws.pub("frontdesk.Practice.entry_canceled", data.entry);

                    if (item['has_appointment']) this.ws.pub(
                        "frontdesk.Calendar.notify",
                        {
                            cmd: UPDATE,
                            type: APPOINTMENT,
                            event: data.appointment.id,
                            event_type: data.appointment.event_type
                        },
                        false
                    );
                });
        }

        patientAlerts(item, ev) {
            this.patientService.patientAlerts(item.patient, ev);
        }

        addNewAlert(item, ev) {
            this.notificationService.alertDialog(item.patient, item.stat, null, ev);
        }

        addNewNotification(item, ev) {
            this.notificationService.notificationDialog(null, item.patient, ev);
        }

        addBiologyResult(item, ev) {
            this.dialog.show(_.assign({}, BIOLOGY_RESULT_DIALOG, {
                targetEvent: ev,
                locals: {
                    patient: item.patient.id
                }
            }));
        }

        medicalCareSchedulingDialog(patient, ev) {
            this.medicalCareService.openSchedulingDialog(patient, null, false, ev);
        }

        openMenu($mdMenu, $event) {
            $event.stopPropagation();
            $mdMenu.open($event);
        }

        updateRoom(ev) {
            this.dialog.show(_.assign({}, ENTRY_ROOM_UPDATE_DIALOG, {
                targetEvent: ev,
                locals: {
                    entry: _.cloneDeep(this.item)
                }
            }));
        }

        patientResume(item, ev) {
            this.frontDeskService.entryResume({
                'entry': item,
                'patient-id': _.get(item, 'patient.id')
            }, ev);
        }

        startNewEntry(stat) {
            this.frontDeskService.checkPatientEntry(this.item.patient.id)
                .then(() => this.newEntrySuccess(stat));
        }

        newEntrySuccess(stat) {
            this.frontDeskService.reopenEntry(this.item, stat)
                .then(data => {
                    this.practiceService.entryAdded(data);
                    this.ws.pub("frontdesk.Practice.entry_added", data);
                });
        }

        isEntryToday() {
            if (!this.dayFilter) return true;
            else return this.item && this.moment(this.item.entry_time).format(this.dateFormat) === this.moment().format(this.dateFormat);
        }

        // rdv related methods
        isToday() {
            return this.item.date === this.moment().format(this.dateFormat);
        }

        createEntry(event, stat, room, ev) {
            switch (event.event_type) {
                case "rdv":
                    return this.frontDeskService.createEntryFromCalendar(event, stat, room)
                        .then(data => {
                            this.notifyCalendar(UPDATE, data.appointment);
                            this.practiceService.entryAdded(data.entry);
                            this.ws.pub("frontdesk.Practice.entry_added", data.entry);
                        });
                case "group-rdv":
                    return this.groupAppointmentService.createEntries(event, ev, stat, room, {selectedPatients: [event.patient_id]});
            }
        }

        editEvent(appointment, ev) {
            switch (appointment.event_type) {
                case "rdv":
                    return this.frontDeskService.editAppointment(appointment, ev);
                case "group-rdv":
                    return this.groupAppointmentService.updateAppointment(ev, null, appointment.id);
            }
        }

        toWaitingList(event) {
            const data = {date: null, start_time: null, end_time: null, ignore: true, is_waiting_list: true};
            this.frontDeskService.partialUpdateAppointment(event.id, data)
                .then(data => this.notifyCalendar(WAITING_LIST, data));
        }

        deleteEvent(event) {
            switch (event.event_type) {
                case "rdv":
                    return this.frontDeskService.removeAppointment(event.id)
                        .then(() => this.notifyCalendar(DELETE, event));
                case "group-rdv":
                    return this.groupAppointmentService.removeAppointment(event)
                        .then(data => {
                            this.notifyCalendar(DELETE, event);
                        });
            }
        }

        notifyCalendar(cmd, data) {
            const event = data.id;
            const event_type = data.event_type;

            this.ws.pub("frontdesk.Calendar.notify", {cmd, type: APPOINTMENT, event, event_type}, false);
        }

        // video call related
        startVideoCall(ev) {
            this.videoCallService.openVideoCall(
                this.item.video_call_room, this.item.patient.id, this.item.video_call_folder, ev
            );
        }

        resendNotification() {
            this.videoCallService.resendNotification(this.item.video_call_room);
        }
    }

    module.exports = {
        bindings: {
            item: "=",
            dayFilter: "<",
            callbacks: "<",
        },
        controllerAs: 'vm',
        controller: PracticeMenuCtrl,
    };

})();
